import styled from '@emotion/styled';

export default styled.div`
  width: 25%;
  padding-right: 30px;
  font-size: 0.875rem;
  color: #8d8d8d;
  line-height: 1.625;
  font-family: ProximaNova-Regular, sans-serif;
  @media (max-width: 768px) {
    width: 50%;
    padding-right: 15px;
  }
`;
